var indentation_default = {
  "indentZero": "Tb4uv",
  "indentOne": "_0NNzl",
  "indentTwo": "i4XUD",
  "indentThree": "_48Tco",
  "indentFour": "wKpP3",
  "indentFive": "_34aNO",
  "indentSix": "bVw-P"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
